import React from 'react';

type DesktopLayoutContextProps = {
  sideBarExpanded: boolean;
  setSideBarExpanded: (expanded: boolean) => void;
};

export const DesktopLayoutContext =
  React.createContext<DesktopLayoutContextProps>({
    sideBarExpanded: false,
    setSideBarExpanded: (_) => {},
  });
